import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BiCart, BiSolidMoon, BiSolidSun } from "react-icons/bi";
import { HiMail, HiMenu } from "react-icons/hi";
import { MdCall } from "react-icons/md";
import { CgClose } from "react-icons/cg";
import { firebase, db } from "../firebaseConfig";
import { useCart } from "react-use-cart";
import { Navlinks } from "./Data";
import ResponsiveMenu from "./ResponsiveMenu";
import logo from "./Asset/logo.png";
// import Logo from "./Asset/NEW YORK LOGO-M4 (1).png";
import { formatPrice } from "../utils/priceFormatter";


const Nav = ({ theme, setTheme }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [user, setUser] = useState(null);
  const [profileData, setProfileData] = useState(null);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  useEffect(() => {
    const element = document.documentElement;
    if (theme === "dark") {
      element.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      element.classList.remove("dark");
      // localStorage.setItem("theme", "light");
    }
  }, [theme]);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((authUser) => {
      setUser(authUser || null);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!user) { setProfileData(null); return; }
    const unsubscribe = db.collection("userss").doc(user.uid)
      .onSnapshot((doc) => {
        if (doc.exists) setProfileData(doc.data());
      });
    return () => unsubscribe();
  }, [user]);

  const { isEmpty, totalItems } = useCart();

  // Add error handling for cart data
  const safeIsEmpty = isEmpty !== undefined ? isEmpty : true;
  const safeTotalItems = totalItems !== undefined ? totalItems : 0;


  return (
    <nav className="lg:w-[90%] w-[95%] lg:h-20 z-10 fixed justify-self-center text-center my-3 flex justify-between items-center lg:p-5 p-3 lg:px-10 bg-[rgba(52,52,52,0.3)] shadow-md rounded-full">
    {/* <nav className="lg:w-[90%] w-[95%] h-20 z-10 fixed justify-self-center text-center my-3 flex justify-between items-center lg:p-5 p-3 lg:px-10 bg-[rgba(255,255,255,0.3)] dark:bg-[rgba(52,52,52,0.3)] shadow-md rounded-full"> */}
    <Link 
    to='/'  
    onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
              }}  
               className="text-2xl font-bold flex items-center cursor-pointer text-green-900">
      {/* <span className="mr-2"> </span> <spn className="hidden lg:inline">Linktree</spn> */}
      <img className="w-14 ml-2 lg:hidden rounded-full" src={logo} alt="" />
      <img className="w-20 hidden rounded-full lg:inline" src={logo} alt="" />
    </Link>
    {/* {
      user &&
    <p className="font-semibold mx-2 text-sm text-white">{`Credit ${formatPrice(profileData?.balance || 0)}`}  </p>
    } */}
    <ul className="hidden md:flex space-x-10 text-white ">
            {Navlinks.map((data, index) => (
              <li
              key={index}
              onClick={()=>setShowMenu(false)}
              >
                <Link 
                  to={data.link} 
                  className="text-sm font-semibold inline-block"
                  onClick={() => {
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
                  }}
                >
                {data.name}
                </Link>
              </li>
            ))}
      <a href="mailto:support@vethinteriors.com" >
        <HiMail className="text-2xl cursor-pointer" />
      </a>
      <a href="tel:+2348106079897" >
        <MdCall className="text-2xl cursor-pointer" />
      </a>
    </ul>
    <div className="space-x-2 align-middle flex justify-evenly items-center">
      {/* <button onClick={handleGoogleSignIn} className="px-5 py-3 rounded-full font-bold bg-gray-200 text-green-900">
        Log in
      </button> */}
    
      {/* <button onClick={handleGoogleSignIn} className="lg:px-8 py-3 px-5 rounded-full font-semibold hover:shadow-lg
       bg-gray-800 text-gray-300 shadow-md">
        Login
      </button> */}
         <Link to="/cart"
         onClick={() => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
        }} 
         className="mr-2">
            <BiCart
              // size="30"
              className="h-6 w-6"
              color={ `#fff`}
              // className="rounded-full shadow-2xl drop-shadow-2xl shadow-gray-700 "
            />
            {!safeIsEmpty && (
              <div className=" absolute top-5 ml-3 text-sm text-white rounded-full w-6 h-6 text-center bg-orange-600">
               <p className='mt-0.5'>
                {safeTotalItems}
                </p> 
              </div>
            )}
          </Link>
        <div
        //  className='hidden lg:inline'
        className='px-2'
         >
          {theme === "dark" ? (
            <BiSolidMoon  onClick={() => setTheme("light")} className="text-2xl text-white cursor-pointer" />
          ) : (
            <BiSolidSun onClick={() => setTheme("dark")} className="text-2xl text-white cursor-pointer" />
          )}
      </div>

      {
        user ?
        <>
        {
          (profileData?.profileImage || user.photoURL) ?
          <Link to='/profile' className="w-10 h-10 rounded-full flex-shrink-0">
            <img src={profileData?.profileImage || user.photoURL} alt="Profile" className="h-10 w-10 rounded-full object-cover border-2 border-amber-400" />
          </Link>
          :
        <Link to='/profile' className="w-9 h-9 rounded-full bg-amber-500 text-white flex items-center justify-center text-lg font-bold">
          {user.displayName?.[0]?.toUpperCase() || profileData?.username?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase() || 'U'}
        </Link>
        }
        </>
        :
        <Link to={"/register"} 
        // onClick={handleGoogleSignIn}
        className="lg:px-8 py-2 px-5 rounded-full hover:shadow-lg
        bg-gradient-to-r from-amber-600 to-yellow-600 text-white lg:text-lg text-sm shadow-md">
        Login
        </Link> 
      }

    <div className="pr-2 lg:hidden"> 
    {showMenu ? (
              <CgClose
                onClick={toggleMenu}
                className="font-bold cursor-pointer rounded-full p-1 transition-all"
                size={40}
                color='white'
              />
            ) : (
              <HiMenu
                onClick={toggleMenu}
                className="cursor-pointer transition-all"
                size={25}
                color='white'

              />
            )}


    </div>

    
    </div>
    <ResponsiveMenu showMenu={showMenu} theme={theme} setTheme={setTheme} setShowMenu={setShowMenu} />
  </nav> 
  )
}

export default Nav